import React from 'react';
import { IconsPros } from '../icons/types';

/**
 * CampaignMonitor Logo component
 *
 * @returns JSX.ELEMENT
 */
export const CampaignMonitorLogo = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 291.92 197.52" data-testid={dataTestId}>
      <path
        fill="#002b45"
        d="M296.39,14.43a11.1,11.1,0,0,0-15.47-2.72L8.49,202.47a11.08,11.08,0,0,0,9.08,4.73H287.3a11.1,11.1,0,0,0,11.1-11.11V20.62a11,11,0,0,0-2-6.19"
        transform="translate(-6.49 -9.69)"
      />
      <path
        fill="#002b45"
        d="M24,11.7A11.11,11.11,0,0,0,8.5,14.42a11,11,0,0,0-2,6.2v175.8L136.2,90.17Z"
        transform="translate(-6.49 -9.69)"
      />
    </svg>
  );
};
